import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import {
  ContractVaultDialogComponent,
  IContractVaultDialogData
} from './contract-vault-dialog.component';

let activeVaultDialogRef: MatDialogRef<ContractVaultDialogComponent> | null = null;

/**
 * Opens the near full-screen Contracts & Compliance Vault modal.
 *
 * @param dialog The Angular MatDialog service instance.
 * @param proposalProfileId The ID or ExtendGUID of the proposal.
 * @param proposalName Optional display name of the proposal.
 * @param contractAppEmbedUrl Optional direct iframe embed URL.
 * @param initialTabIndex Optional initial active tab index (0 = Contract Workspace, 1 = Archived Artifacts).
 */
export function openContractVaultDialog(
  dialog: MatDialog,
  proposalProfileId: string,
  proposalName?: string,
  contractAppEmbedUrl?: string,
  initialTabIndex: number = 0
): MatDialogRef<ContractVaultDialogComponent> | null {
  if (activeVaultDialogRef) {
    return activeVaultDialogRef;
  }

  const dialogData: IContractVaultDialogData = {
    proposalProfileId,
    proposalName,
    contractAppEmbedUrl,
    initialTabIndex
  };

  activeVaultDialogRef = dialog.open(ContractVaultDialogComponent, {
    width: '96vw',
    maxWidth: '98vw',
    height: '92vh',
    maxHeight: '96vh',
    disableClose: false,
    autoFocus: false,
    panelClass: 'contract-vault-dialog-panel',
    data: dialogData
  });


  activeVaultDialogRef.afterClosed().subscribe(() => {
    activeVaultDialogRef = null;
  });

  return activeVaultDialogRef;
}
